import { Button, Form, Row, Spin } from "antd";
import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import OrganizationSelect from "./OrganizationSelect";
import KitsRemarks from "./KitsRemark";
import {
  AppDispatch,
  getChildOrganizationList,
  getChildOrganizationListRequest,
  getKitListRequest,
  getMyOrganization,
  transferKit,
  transferKitClear,
  transferKitRequest,
  useDynamicSelector,
} from "@src/redux";
import { useDispatch, useSelector } from "react-redux";
import DynamicSelect from "./DynamicSelect";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import DynamicTreeSelect from "../../common/TreeSelect";

interface KitsTransferFormProps {
  handleCancel: () => void;
  selectedId: any;
}

const KitsTransferForm: React.FC<KitsTransferFormProps> = ({
  handleCancel,
  selectedId,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();

  const { id } = useParams();
  const [organizationForm] = Form.useForm();

  const {
    result: transferKitStatus,
    error: transferKitError,
    loading: transferKitLoading,
  } = useSelector(transferKit);
  const { result } = useSelector(getMyOrganization);
  const { filter } = useDynamicSelector("subject_filter");

  const organizations = Form.useWatch("organizationId", organizationForm);

  useEffect(() => {
    if (transferKitStatus?.status === "success") {
      toast.success("Kit Transferred");
      getKitLists();
      dispatch(transferKitClear());
    } else if (transferKitStatus?.error?.message) {
      toast.error(transferKitStatus?.error?.message);
      dispatch(transferKitClear());
    }
  }, [transferKitStatus, transferKitError]);

  const getKitLists = () => {
    dispatch(
      getKitListRequest({
        filter: {
          organizationId: filter?.organizationId || result?.id || "",
        },
      })
    );
  };

  const handleSubmit = (values: any) => {
    values.organizationId =
      values.organizationId[values.organizationId?.length - 1];
    dispatch(
      transferKitRequest({
        id: selectedId,
        data: {
          organizationId: values.organizationId,
        },
      })
    );
  };

  return (
    <>
      <Form layout="vertical" onFinish={handleSubmit} form={form}>
        <Row gutter={24}>
          <DynamicTreeSelect
            form={form}
            col={24}
            kitAssignCheck={true}
            mutationType="add"
            isRequired={false}
            allowClear={false}
            showAllLabel={false}
          />
        </Row>
        {/* <KitsRemarks /> */}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Form.Item>
            <Button
              style={{ marginRight: "10px" }}
              onClick={handleCancel}
              danger
            >
              {t("close")}
            </Button>
            <Button
              // className="transfer-button"
              htmlType="submit"
              loading={transferKitLoading}
              type="primary"
            >
              {t("transfer")}
            </Button>
          </Form.Item>
        </div>
      </Form>
    </>
  );
};

export default KitsTransferForm;
